import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import flyover from '../../../Assets/Images/Training/Training Program/flyover.jpg'

const Rethinking_Public_Spaces_Under_Fly_Overs = () => {
    return (
        <div className="mt-5">
            <h4>3 - Days Professional Development Program on ‘Rethinking’ Public Spaces Under Fly-Overs</h4>

            <div className="card mt-5">
                <img
                    src={flyover}
                    className="card-img-top"
                    alt="Poster"
                />
            </div>
            <Link to="https://www.re-thinkingthefuture.com/architects-lounge/a1288-recycling-urban-spaces-15-under-flyover-projects-around-the-world/" target='_blank'>
                <p className='text-primary text-end'>Image Credit Goes To</p>
            </Link>

            <div className="mt-5">
                <p>This professional development program addresses the critical challenge of neglected and underutilized urban spaces beneath flyovers. These areas often contribute to safety, sanitation, and social exclusion issues, representing a significant missed opportunity for urban enhancement. This program equips urban planners, policymakers, architects, and engineers with the strategic skills to transform these derelict zones. Participants will explore innovative, real-world case studies from Delhi and beyond, learning to identify opportunities for creative and functional reclamation. The curriculum covers design principles, community engagement, funding models, and regulatory navigation. The ultimate aim is to empower professionals to convert these underutilized sites into vibrant, safe, and integrated public spaces. By attending, you will gain the expertise to drive strategic interventions that create more sustainable, equitable, and liveable cities, transforming urban vulnerabilities into valuable community assets.</p>
            </div>

            <div>

                <p><strong>Beneficiaries:</strong> Urban managers from ULBs, Urban Development Authorities, State/PSU project units, contractors, Urban Planners and Designers, Architects and Landscape Architects, Municipal Policymakers and Public Officials, Civil and Transportation Engineers, Community Organizers and NGO Representatives, Real Estate Developers and Urban Managers, Researchers, Academics, and Students in related fields.</p>
                <p><strong>Aim:</strong> To systematically identify the indicators for analyzing under-flyover spaces as defunct and derelict spaces, and identify the issues, governing factors, and potentials for transforming these spaces into usable urban spaces.</p>

                <p><strong>Objectives:</strong></p>
                <ul>
                    <li>To conduct a systematic literature review (SLR) and existing best practices for adaptive reuse of under-flyover spaces.</li>
                    <li>To identify the thematic determinants and indicators for developing the usability index</li>
                    <li>To develop the usability index for assessing the usability score of under-flyover spaces for pilot case studies.</li>
                    <li>To identify the pilot case studies for under-flyover spaces.</li>
                    <li>To assess the usability score of pilot case studies.</li>
                    <li>To identify the governing factors and potential for adaptive reuse of under-flyover spaces.</li>
                </ul>

                <p className='mt-4'><strong>Timeline & Duration:</strong> 3 days - 24 Hours (2-4 Credits)</p>
                <p className='mt-4'><strong>Mode:</strong> Non-Hybrid and Non-blended (Offline)</p>

            </div>

        </div>
    );
};

export default Rethinking_Public_Spaces_Under_Fly_Overs;